import { useContext, useEffect, useRef } from 'react';
import { useActiveBrandIdentifier } from '@trinity/chat-components/containers/UserBrands/useActiveBrandIdentifier.js';
import {
  SetActiveBrandContext,
  UserBrandsContext,
} from '@trinity/chat-components/containers/UserBrands/UserBrandsContext.js';

const HACKATHON_BRAND_NAMES = ['jnj hackathon', 'hackathon'];

export function useForceHackathonBrand(): void {
  const brands = useContext(UserBrandsContext);
  const setActiveBrand = useContext(SetActiveBrandContext);
  const currentBrand = useActiveBrandIdentifier();
  const appliedRef = useRef(false);

  const brandsLoaded = brands.length > 0;

  useEffect(() => {
    if (appliedRef.current || !brandsLoaded || !setActiveBrand) return;

    const match = brands.find((b) => HACKATHON_BRAND_NAMES.includes(b.name.toLowerCase()));
    if (!match) return;

    appliedRef.current = true;
    if (currentBrand !== match.identifier) {
      setActiveBrand(match.identifier);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run once when brands first load, not on every context change
  }, [brandsLoaded]);
}
